import { Routes, Route } from "react-router-dom";
import { LandingPageV2, LoginWithLinkedinCallback } from "Features/LandingPage";
import { Home } from "Features/Home/Home";

import { ProtectedRoute } from "./ProtectedRoute";
import { MyCalendar } from "Features/MyCalendar/MyCalendar";
import { DescriptionPage } from "Features/Auth/Description";
import { ProfileForm } from "Features/ProfileForm";
import { PublishSlots } from "Features/ManageSlots/PublishSlots/PublishSlots";
import { ROUTES } from "Constants/AllRoutes";
// import { Payments } from "Features/Payments/Payments";
import { EditSlots } from "Features/ManageSlots/EditSlots/EditSlots";
import { ProfilePage } from "Features/Profile/Profile";
import { TermsPage } from "Features/Legal/TermsPage";
import { PartnerTermsPage } from "Features/Legal/PartnerTermsPage";
import OurTeam from "Features/OurTeam";
import Blog from "Features/Blog";
import SingleBlog from "Features/Blog/SingleBlog";

export const RouterWrapper = () => {
  return (
    <>
      <Routes>
        <Route path={ROUTES.HOME} element={<LandingPageV2 />} />
        <Route path={ROUTES.OUR_TEAM} element={<OurTeam />} />
        <Route path={ROUTES.BLOG} element={<Blog />} />
        <Route path={ROUTES.TERMS} element={<TermsPage />} />
        <Route path={ROUTES.PARTNER_TERMS} element={<PartnerTermsPage />} />
        <Route path={ROUTES.SINGLE_BLOG} element={<SingleBlog />} />
        <Route
          path={ROUTES.LINKEDIN_CALLBACK}
          element={<LoginWithLinkedinCallback />}
        />
        <Route
          path={ROUTES.REGISTER_ROLE}
          element={
            <ProtectedRoute>
              <DescriptionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PROFILE_FORM}
          element={
            <ProtectedRoute>
              <ProfileForm />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.MY_CALENDAR}
          element={
            <ProtectedRoute>
              <MyCalendar />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.DASHBOARD_HOME}
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PUBLISH_SLOTS}
          element={
            <ProtectedRoute>
              <PublishSlots />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.EDIT_SLOTS}
          element={
            <ProtectedRoute>
              <EditSlots />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path={ROUTES.PAYMENTS}
          element={
            <ProtectedRoute>
              <VerifiedUserProtectedRoute>
                <Payments />
              </VerifiedUserProtectedRoute>
            </ProtectedRoute>
          }
        /> */}
        <Route
          path={ROUTES.PROFILE}
          element={
            <ProtectedRoute>
                <ProfilePage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
};
